module.exports = __webpack_public_path__ + "img/experience_enhancement_3.2a7de3dd.png";